import { mutatorAction } from 'satcheljs';
import { store } from '../store/store';

const setUseSystemDarkModeSettingsMutator: (useSystemDarkModeSettings: boolean) => void =
    mutatorAction('SET_USE_SYSTEM_DARK_MODE', (useSystemDarkModeSettings: boolean): void => {
        store().useSystemDarkModeSettings = useSystemDarkModeSettings;
    });
export default setUseSystemDarkModeSettingsMutator;
